export const talentProgramSource = [
  // { value: null, label: "Select Specialization" },
  { value: "socialMedia", label: "Social Media" },
  { value: "friendOrFamily", label: "Friend/Family" },
  { value: "googleAds", label: "Google Ads" },
  { value: "other", label: "Other" },
];
